// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ProductionOperators_RemoverInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/production_operators/remover
 *
 * Soft-delete a production operator (sets is_active = 0).
 */
import { registerContract } from './validate'

export interface ProductionOperators_RemoverInput {
production_operator_id: number
}

registerContract('ProductionOperators_RemoverInput', {
  production_operator_id: { type: 'number',  required: true },
})
